import React from 'react';
import {Image} from "antd";

function AuthCardHeaderSection({title, description}) {
    return (
        <div>
            <div className={'mt-6'}>
                <div className="text-2xl text-center">
                    <Image width={100} src={'/logo.png'} preview={false} className={'rounded-lg'}/>
                </div>
                <div className="text-2xl font-bold text-center">{title}</div>
                <div className={'text-center mt-2'}>
                    {description}
                </div>
            </div>
        </div>
    );
}

export default AuthCardHeaderSection;